import {
  setDoc,
  collection,
  getDocs,
  deleteDoc,
  doc,
  collectionGroup,
  updateDoc,
  onSnapshot,
} from "firebase/firestore";
import { useEffect } from "react";
import { db } from "../firebase";

const SHOP_COLLECTION = "shopItems-v2";

// ✅ Fetch all user purchases (across all users)
export const fetchAllPurchases = async () => {
  const snapshot = await getDocs(collectionGroup(db, "purchaseHistory"));

  return snapshot.docs.map((doc) => {
    const data = doc.data();
    const userId = doc.ref.path.split("/")[1]; // from users/{userId}/purchaseHistory/{purchaseId}
    return {
      id: doc.id,
      userId,
      ...data,
    };
  });
};

// ✅ Update purchase status
export const updatePurchaseStatus = async (userId, purchaseId, status) => {
  const ref = doc(db, `users/${userId}/purchaseHistory/${purchaseId}`);
  await updateDoc(ref, { status });
};

// ✅ Fetch all shop items (defaulting to OCG collection)
export const fetchShopItems = async (collectionName = SHOP_COLLECTION) => {
  const snapshot = await getDocs(collection(db, collectionName));
  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
};

// ✅ Real-time shop items listener
export const useShopItemsListener = (collectionName = SHOP_COLLECTION, setShopItems) => {
  useEffect(() => {
    const shopCol = collection(db, collectionName);
    const unsubscribe = onSnapshot(shopCol, (snapshot) => {
      const itemList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setShopItems(itemList);
    });

    return () => unsubscribe();
  }, [collectionName, setShopItems]);
};

// ✅ Add a new item to specified collection
export const addShopItem = async (item, docId, collectionName = SHOP_COLLECTION) => {
  try {
    const itemRef = doc(db, collectionName, docId);
    await setDoc(itemRef, item);
  } catch (error) {
    console.error("❌ Error adding shop item:", error.message);
    throw error;
  }
};

// ✅ Delete an item from a specified collection
export const deleteShopItem = async (itemId, collectionName = SHOP_COLLECTION) => {
  await deleteDoc(doc(db, collectionName, itemId));
};
